<template>
  <div style="position: relative" id="app">
    <PageHeader v-if="showHeader()"/>
    <Policy v-if="$auth.check() && !policyApplied"/>
    <template v-else>
      <Sidebar
        v-if="showSidebar()"
        />
      <div class="main-content" :class="getMainContentClasses()">
        <router-view/>
        <!-- <Footer v-if="showFooter()"></Footer> -->
      </div>
    </template>
    <Footer v-if="showFooter()"></Footer>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import PageHeader from '@/components/layouts/PageHeader'
import Sidebar from '@/components/layouts/Sidebar'
import Footer from '@/components/layouts/Footer'
import Policy from '@/components/Policy'
import MasterDataApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'

export default {
  name: 'App',
  components: {PageHeader, Sidebar, Footer, Policy},
  watch: {
    '$auth.watch.authenticated': function (val) {
      if (val) {
        let $ = this
        this.fetchMeetingCategories({
          error: (_error) => apiErrorDialog($, _error)
        })
      }
    }
  },
  computed: {
    policyApplied: function () {
      return localStorage.getItem('policy_applied') === 'true'
    }
  },
  methods: {
    ...mapActions({
      fetchMeetingCategories: 'meetings/fetchMeetingCategories'
    }),
    showHeader () {
      if (!this.$auth.check()) return false
      if (this.$router.currentRoute.name === 'shareCall') return false
      if (this.$router.currentRoute.name === 'meetings.call') return false
      return true
    },
    showSidebar () {
      if (!this.$auth.check()) return false
      if (this.$router.currentRoute.name === 'shareCall') return false
      if (this.$router.currentRoute.name === 'meetings.call') return false
      return true
    },
    showFooter () {
      if (this.$router.currentRoute.name === 'shareCall') return false
      if (this.$router.currentRoute.name === 'meetings.call') return false
      return true
    },
    getMainContentClasses () {
      this.handleMaintenanceMode()

      let classes = ''
      if (this.$auth.check() &&
        this.$router.currentRoute.name !== 'shareCall' &&
        this.$router.currentRoute.name !== 'meetings.call') {
        classes = 'logged-in'
      }
      return classes
    },
    async handleMaintenanceMode () {
      await MasterDataApi.get()
        .catch((error) => apiErrorDialog(this, error))
    }
  }
}
</script>

<style lang="scss">
@import "./assets/sass/main";
</style>



// WEBPACK FOOTER //
// src/App.vue